import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function deleteUser(userId: string): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.delete(`/users/${userId}`);
  return response;
}

const useDeleteUser = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['delete', `/users/:id`],
    mutationFn: (userId: string) => deleteUser(userId),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useDeleteUser;
